import { FontSizeToken, TFontSize } from './fontSize'
import { FontWeightToken, TFontWeight } from './fontWeight'
import { FontHeightToken, TLineHeight } from './lineHeight'

export default {
  fontSize: FontSizeToken,
  fontHeight: FontHeightToken,
  fontWeight: FontWeightToken,
}

export type TTypographyV2 = TFontSize | TLineHeight | TFontWeight
